<section class="features">
  <div class="features--container">
    <!-- Title -->
    <h2 class="features--title">Features of MahaAgX</h2>

    <!-- Tabs -->
    <div class="features--tabs">
      <button
        *ngFor="let tab of tabs"
        class="features--tab"
        [class.features--tab--active]="activeTab === tab.id"
        (click)="switchTab(tab.id)"
      >
        {{ tab.label }}
      </button>
    </div>

    <!-- Description -->
    <p class="features--description">{{ currentTab.description }}</p>

    <!-- View All Link -->
    <button (click)="onViewAll()" class="features--view-all">
      {{ currentTab.viewAllText }}
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>

    <!-- Carousel with Cards -->
    <div class="features--carousel-wrapper">
      <app-carousel 
        *ngIf="currentCards.length > 0"
        [items]="currentCards" 
        [itemsToShow]="itemsToShow"
        [showDots]="true"
        [showArrows]="true"
        [gap]="24"
        (slideChange)="onSlideChange($event)"
      >
        <div 
          *ngFor="let card of currentCards; let i = index" 
          class="carousel-item"
        >
          <!-- Model Cards for Models tab -->
          <app-model-card 
            *ngIf="activeTab === 'ai-models'"
            [card]="$any(card)"
            [showActivityMetrics]="true"
          ></app-model-card>
          <!-- Feature Cards for Datasets tab -->
          <app-feature-card 
            *ngIf="activeTab === 'datasets'"
            [card]="$any(card)"
            [showActivityMetrics]="true"
          ></app-feature-card>
        </div>
      </app-carousel>
      
      <!-- Loading state -->
      <div *ngIf="isLoading" class="features--loading">
        Loading...
      </div>
    </div>
  </div>
</section>